export const getArray = (children: any) => {
  return !Array.isArray(children) ? [children] : children
}
